export default class wdkDialogBodyFreestyle extends HTMLElement {
	async connectedCallback() {
		const template = document.createElement('template');
		template.innerHTML = `
			<style>
				:host {
					display: block;
				}
				
				@media only screen and (min-width: 601px) {
					:host {
						width: var(--wdk-dialog-width-desktop);
					}
				}
				
				@media only screen and (max-width: 600px) {
					:host([mobile-full-height]) .dialogContent {
						height: 100dvh;
						max-height: 100dvh;
						border-top-left-radius: 0;
						border-top-right-radius: 0;
					}
				}
			</style>
			<div class="dialogContent">
				<article><slot></slot></article>
			</div>
		`;
		const clone = document.importNode(template.content, true);
		if (!this.shadowRoot) {
			this.attachShadow({ mode: 'open' });
			this.shadowRoot.appendChild(clone);
		}
	}
}
